// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let NoteBlankSlateView
require("./styles/note-blank-slate.css")

export default NoteBlankSlateView = (function () {
  NoteBlankSlateView = class NoteBlankSlateView extends (
    require("lib/static-shim").default(require("lib/core/item-view").default)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/note-blank-slate.html")
      this.prototype.className = "note-blank-slate-view"

      this.prototype.triggers = { "click #add-note": "add:note" }
    }

    initialize() {
      return _.defaults(this.options, { hasAccess: true })
    }

    onRender() {
      if (this.options.disabledMessage) {
        this.disable()
      }
      return _.defer(() => {
        const $icons = this.$(".pathicons-container > li")
        this.rotate($icons.slice(0, 4))
        return this.rotate($icons.slice(3))
      })
    }

    disable() {
      this.$("#add-note").addClass("disabled")
      return this.$(".add-note-container").popover({ trigger: "hover click" })
    }

    serializeData() {
      const data = super.serializeData()
      data.perms = window.App.getStore("note").request.getNotePermissions()
      data.title = this.options.title
      data.message = this.options.disabledMessage
      data.has_access = this.options.hasAccess
      return data
    }

    // Rotating the pathicons for a nice effect
    rotate($icons) {
      $($icons[0]).velocity({
        duration: 10000,
        translateY: "-15px",
        rotateZ: "-10deg"
      })

      $($icons[1]).velocity({
        duration: 10000,
        translateY: "15px"
      })

      return $($icons[2]).velocity({
        duration: 10000,
        rotateZ: "10deg"
      })
    }

    onClose() {
      return this.menu.destroy()
    }
  }
  NoteBlankSlateView.initClass()
  return NoteBlankSlateView
})()
